import { render, staticRenderFns } from "./propertyInfo.vue?vue&type=template&id=b24a311e&scoped=true&"
import script from "./propertyInfo.vue?vue&type=script&lang=js&"
export * from "./propertyInfo.vue?vue&type=script&lang=js&"
import style0 from "./propertyInfo.vue?vue&type=style&index=0&id=b24a311e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24a311e",
  null
  
)

export default component.exports